import { Link } from 'react-router-dom';
import BrandLogo from '../../components/common/BrandLogo';
import { MdHourglassTop } from 'react-icons/md';

function PendingApproval() {
  return (
    <div className="min-h-screen bg-[#141312] flex flex-col items-center justify-center px-4">
      <div className="flex items-center gap-2 mb-8">
        <BrandLogo size={28} />
        <span className="font-bold text-[#ede8e0] text-xl">TrainAxis</span>
      </div>

      <div className="bg-[#1e1d1b] rounded-2xl border border-[rgba(237,232,224,0.08)] shadow-2xl p-8 max-w-sm w-full text-center">
        <div className="w-16 h-16 bg-amber-500/15 rounded-full flex items-center justify-center mx-auto mb-4">
          <MdHourglassTop className="text-amber-500 text-4xl" />
        </div>
        <h2 className="text-[#ede8e0] font-bold text-xl mb-2">Awaiting Approval</h2>
        <p className="text-[#8a847c] text-sm mb-6">
          Your account is pending admin approval. You'll receive an email once your account is approved.
        </p>
        <Link to="/login">
          <button className="w-full bg-primary text-white hover:bg-primary-dark py-3 rounded-full font-medium">
            Back to Login
          </button>
        </Link>
      </div>
    </div>
  );
}

export default PendingApproval;
